"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayThresholdRule = (options) => {
    if (options.stringArrayThreshold === 0) {
        options = Object.assign(Object.assign({}, options), { rotateStringArray: false, stringArray: false, stringArrayEncoding: false, stringArrayThreshold: 0 });
    }
    return options;
};
